import React, { FC } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import toast from 'react-hot-toast';
import { ReactComponent as CopyIconSVG } from '../svg/copy-icon.svg';

import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

type ModalPurchaseNFTProps = {
  isOpen: boolean;
  toggle(): void;
  projectId: number;
};

const ModalPublishedProject: FC<ModalPurchaseNFTProps> = ({ isOpen, toggle, projectId }) => {
  const projectLink = `${location.origin}/projects/${projectId}`;

  const copyProjectLink = () => {
    copy(projectLink);
    toast.success('Copied');
  };
  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-published-project">
        <ModalHeader toggle={toggle}>Project published successfully</ModalHeader>
        <ModalBody>
          <div className="modal-published-project--body">
            <div className="link-content">{projectLink}</div>
            <CopyIconSVG
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                copyProjectLink();
                toggle();
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button onClick={toggle} className="app-btn color-primary">
            Close
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

ModalPublishedProject.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

ModalPublishedProject.defaultProps = {
  toggle: () => {},
};

export default ModalPublishedProject;
